import CreateSchoolWizard from './CreateSchoolWizard.provider';

export default CreateSchoolWizard;
